import http from '@root/utils/axios/admin';

let state = {
    CarYearsList: [],
    CarYear: {
        data: {},
        error: {}
    }
}

let actions = {

    fetchCarYearsList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('subscriber/car-years', { params: filter }).then((response) => {
                commit('setCarYearsList', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },
    fetchCarYear({ commit }, id) {
        return new Promise((resolve, reject) => {
            http.get('subscriber/car-years/' + id).then((response) => {
                commit('setCarYear', response.data.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

}


let mutations = {
    setCarYearsList(state, data) {
        state.CarYearsList = data;
    },
    setCarYear(state, data) {
        state.CarYear.data = data;
    },

}

export default {
    state,
    actions,
    mutations
}